<template>
  <div class="box-form box-form-products">
    <v-form>
      <v-card-text class="modal-cadastro-form">
        <v-row class="align-center">
          <v-col cols="5" class="modal-cadastro-form-col-imput">
            <v-autocomplete
              v-model="contrato"
              :items="listaItensComissoes"
              label=""
              item-text="name"
              item-value="id"
              :error-messages="errorContrato"
              return-object
            />
          </v-col>
          <v-col cols="4" class="modal-cadastro-form-col-imput">
            <v-btn
              :color="variables.colorPrimary"
              @click.prevent="adicionarContrato"
              class="br-btn"
              :loading="loading"
              dense>Adicionar</v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="modal-cadastro-form-col-imput">
            <template v-for="(data, idx) in itensReferencias">
              <v-card
                class="mx-auto"
                max-width="550"
                :key="idx"
              >
                <v-card-title class="modal-cadastro-titulo justify-space-between py-2 px-2" color="#FFF">
                  <div>{{ data.name }} </div>
                  <v-icon @click="deleteContrato(idx)" color="#FFF">
                     mdi-delete
                  </v-icon>
                </v-card-title>
                <v-card-text>
                  <v-row align="center">
                    <v-col
                      cols="6"
                    >
                      Nome
                    </v-col>
                    <v-col cols="6">
                      {{ data.name }}
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="21"
                    >
                      <v-simple-table dense>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left">
                                Level
                              </th>
                              <th class="text-left">
                                %
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="range in data.referenceComissionValues"
                              :key="range.id"
                            >
                              <td>{{ range.level }}</td>
                              <td>{{ range.aliquot }}</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card> 
            </template>
          </v-col>
        </v-row>
      </v-card-text>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
// import Events from '@/core/service/events'
// import { currency } from '@/core/service/utils'
// import { cnpj } from 'cpf-cnpj-validator'
import variables from '@/assets/styles/helpers/_variables.scss'
import { cloneDeep } from 'lodash'
// import vmoney from '@/views/components/vMoney'
import validacao from './validateReferencia'

// const validCNPJ = (params) => {
//   console.log(params)
// }

function isValidContrato(listaContratosAdicionados) {
return () => {
return !listaContratosAdicionados.length
}
}

export default {
  name: 'BrModalCadastroAts',
  mixins: [validationMixin],
  directives: {mask},
  components: {
    // comissao: () => import('./comissao')
  },
  props: {
    affiliateId: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    activeModal: false,
    loading: false,
    search: '',
    divider: '/',
    loadingTable: false,
    listaContratosAdicionados: [],
    typeContractSelected: '',
    loadingContrato: false
  }),
  watch: {
    // 'itemEntityProducts.comission' (val) {
    //   console.log(val)
    //   if (val > 100) this.itemEntityProducts.comission = 100
    // }
    'typeContractSelected' (val) {
      this.loadingContrato = true
      this.obterContratos({ _addlFilter: { 'ContractsAffiliate:contractTypeId_=': val } })
        .finally(() => { this.loadingContrato = false })
    }
  },
  computed: {
    ...mapGetters('roles', ['permiteAcao']),
    ...mapGetters('AffiliateReferenceComissionPlans', {
      listaRefenreciaComissoes: 'itensSelect',
      listaItensComissoes: 'listaItens'
    }),
    ...mapGetters('afiliadosPendentes', {
      itensReferencias: 'itensReferencias',
    }),
    variables: () => variables,
    ...validacao
  },
  mounted () {
    this.obterReferenciaComissoes()
    this.obterReferenciasCadastrados(this.affiliateId)
  },
  methods: {
    ...mapActions('AffiliateReferenceComissionPlans', {
      obterReferenciaComissoes: 'getItens'
    }),

    ...mapActions('afiliadosPendentes', {
      obterReferenciasCadastrados: 'obterReferenciasCadastrados',
      removerReferencia: 'removerReferencia',
      setListaReferenciasAdicionado: 'setListaReferenciasAdicionado'
    }),


    setTypeContract (typeContractId) {
      this.typeContractSelected = typeContractId
    },

    deleteContrato (idx) {
      this.removerReferencia(idx)
    },

    adicionarContrato () {
      if (this.$v.contrato.$invalid) { 
        this.$v.contrato.$touch()
        return false 
      }
      this.setListaReferenciasAdicionado(cloneDeep(this.contrato))
      this.contrato = ''
    }
  },

  validations () {
    return  {
      contrato: {
        required,
        isValidContrato: isValidContrato(this.itensReferencias)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../../assets/styles/components/formularios';
  @import '../../../../assets/styles/components/modal-cadastro';
  .br-btn-entity-products {
    margin-top: 10px;
    min-width: auto !important;
    font-size: 0.8em !important;
  }

  .modal-cadastro-titulo {
    background: #6d7278;
    color: #FFF !important;
  }
</style>